import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import { useI18n } from '../i18n/LanguageProvider';

const NotFound = () => {
  const { t } = useI18n();
  return (
    <section className="section">
      <div className="container center">
        <h1>404</h1>
        <p className="muted">{t('notFound.message', 'Page not found.')}</p>
        <Link to="/"><Button variant="primary">{t('notFound.back', 'Go home')}</Button></Link>
      </div>
    </section>
  );
};
export default NotFound;
